import * as React from 'react';

interface WarningIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const WarningCircleIcon = ({color = '#212124', size = 20}: WarningIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" color={color}>
    <g clipPath="url(#a)">
      <path
        fill="#D84018"
        d="M8 0a8 8 0 1 0 8 8 8.008 8.008 0 0 0-8-8Zm-.615 4.308a.615.615 0 1 1 1.23 0v4.307a.615.615 0 0 1-1.23 0V4.308Zm.615 8a.923.923 0 1 1 0-1.845.923.923 0 0 1 0 1.845Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default WarningCircleIcon;
